<template>
    <v-card flat class="transparent">
      <v-layout>
        <v-flex xs12>
          <v-card-text>
            <div class="fullwidth">
              <div class="headline">Openingstijden</div>
              <div >
                <table class="fullwidth">
                  <tbody>
                    <template v-for="(day, x) in openingTimes">
                      <tr :key="day.title + x">
                        <td :class="[x > 0 ? 'pt-3' : '']">{{day.title}}</td>
                        <td :class="[x > 0 ? 'pt-3' : '']" v-if="day.slots.length">{{day.slots[0].from}}u t/m {{day.slots[0].to}}u</td>
                        <td :class="[x > 0 ? 'pt-3' : '']" v-if="!day.slots.length">Gesloten</td>
                      </tr>
                      <tr v-for="(slot, y) in day.slots" v-if="y > 0" :key="x+y">
                        <td>&nbsp;</td>
                        <td>{{slot.from}}u t/m {{slot.to}}u</td>
                      </tr>
                    </template>
                  </tbody>
                </table>
                <hr class="my-2">
                <p class="font-italic">Indien gewenst is, na overleg, een afspraak op zaterdag ook mogelijk.</p>
                  <!-- <v-flex xs6>{{day.title}}</v-flex>
                  <v-flex xs6>
                    <div v-for="(slot, y) in day.slots" :key="`slot${x}${y}`">
                      <v-layout>
                        <v-flex xs4>{{slot.from}}u</v-flex>
                        <v-flex xs2>t/m</v-flex>
                        <v-flex xs4>{{slot.to}}u</v-flex>
                      </v-layout>
                    </div>
                  </v-flex> -->
                <!-- </v-layout> -->
              </div>
            </div>
          </v-card-text>
        </v-flex>
      </v-layout>
    </v-card>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {
    openingTimes() {
      return this.$store.getters.openingTimes;
    }
  },
  methods: {}
};
</script>

<style>
</style>
